import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { 
  Building2, 
  Wrench, 
  ShoppingCart, 
  Utensils, 
  Heart, 
  Briefcase,
  Hammer,
  GraduationCap,
  Car,
  Home,
  Palette,
  Stethoscope,
  Truck,
  Laptop,
  TreePine
} from 'lucide-react';

const BranchenSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const branchen = [
    { icon: Building2, name: 'Dienstleistungen', count: '8.500+' },
    { icon: Wrench, name: 'Handwerk', count: '6.200+' },
    { icon: ShoppingCart, name: 'Einzelhandel', count: '7.800+' },
    { icon: Utensils, name: 'Gastronomie', count: '4.300+' },
    { icon: Heart, name: 'Gesundheitswesen', count: '3.900+' },
    { icon: Briefcase, name: 'Beratung', count: '2.100+' },
    { icon: Hammer, name: 'Bauwesen', count: '5.400+' },
    { icon: GraduationCap, name: 'Bildung', count: '1.800+' },
    { icon: Car, name: 'Automobilindustrie', count: '2.600+' },
    { icon: Home, name: 'Immobilien', count: '1.900+' },
    { icon: Palette, name: 'Kreativwirtschaft', count: '1.400+' },
    { icon: Stethoscope, name: 'Ärzte & Therapeuten', count: '3.200+' },
    { icon: Truck, name: 'Logistik & Transport', count: '2.700+' },
    { icon: Laptop, name: 'IT & Software', count: '1.600+' },
    { icon: TreePine, name: 'Land- & Forstwirtschaft', count: '800+' }
  ];

  return (
    <section ref={ref} className="py-24 bg-[#FAF3E0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Alle relevanten Branchen
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Von Handwerk bis IT, von Gesundheitswesen bis Logistik – 
            unsere Datenbank deckt alle wichtigen Branchen ab. 
            Finden Sie genau die Unternehmen, die zu Ihrem Geschäft passen.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {branchen.map((branche, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.5, delay: 0.05 * index }}
              whileHover={{ scale: 1.05, y: -5 }}
              className="bg-white rounded-2xl p-6 text-center shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 group cursor-pointer"
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-[#2835F7] to-[#1a25c9] rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <branche.icon className="w-8 h-8 text-white" />
              </div>
              <h3 className="font-bold text-gray-900 mb-1 text-sm">{branche.name}</h3>
              <p className="text-[#2835F7] font-semibold text-xs">{branche.count} Kontakte</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-12 text-center"
        >
          <p className="text-gray-600 text-lg">
            <span className="font-bold text-[#2835F7]">15+ Branchen</span> mit über <span className="font-bold text-[#2835F7]">50.000 Kontakten</span> – 
            und es werden täglich mehr!
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default BranchenSection;